import { lazy, Suspense } from "react";

/**
 * Page-wide globe backdrop. Fixed to the viewport behind all home sections so
 * the hero, stats, timelines, and CTA share one continuous 3D background.
 *
 * Layering notes:
 *  - `fixed inset-0`: viewport-anchored, scrolls with nothing
 *  - `z-0`: below the content layer (which sits at `z-10` in Home.tsx)
 *  - `pointer-events-none`: users interact with content, not the globe
 *
 * The globe itself is heavy so it's lazy-loaded behind Suspense — the initial
 * HTML renders instantly with the static vignette fallback underneath.
 */
const HeroScene = lazy(() => import("./HeroScene"));

const HomeBackdrop = () => (
    <div
        aria-hidden
        className="fixed inset-0 z-0 pointer-events-none"
        style={{ contain: "strict" }}
    >
        <Suspense fallback={null}>
            <HeroScene />
        </Suspense>

        {/* Uniform veil across the viewport so text stays legible over every
            section — no per-section vignette that would create a visible seam
            between the hero and the content below it. Slightly denser at the
            top + bottom so navbar and footer retain contrast. */}
        <div
            aria-hidden
            className="absolute inset-0 pointer-events-none"
            style={{
                background:
                    "linear-gradient(180deg, hsl(240 33% 4% / 0.55) 0%, hsl(240 33% 4% / 0.28) 12%, hsl(240 33% 4% / 0.28) 88%, hsl(240 33% 4% / 0.7) 100%)",
            }}
        />
    </div>
);

export default HomeBackdrop;
